export default "__VITE_ASSET__b0760ba1__"